var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0455 1.63074H20.9643C10.7435 1.63074 2.45801 9.88904 2.45801 20.0762V49.279C2.45801 59.4662 10.7435 67.7245 20.9643 67.7245H50.0455C60.2662 67.7245 68.5518 59.4662 68.5518 49.279V20.0762C68.5518 9.88904 60.2662 1.63074 50.0455 1.63074Z",
    fill: "#FF5A84"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3921 17.6716C52.9478 17.226 52.2264 17.226 51.7814 17.6716L19.6921 49.7616C19.2472 50.2059 19.2472 50.928 19.6921 51.3729C19.9143 51.5951 20.2055 51.7061 20.4974 51.7061C20.7886 51.7061 21.0806 51.5956 21.3027 51.3722L53.3921 19.2823C53.8371 18.838 53.8371 18.1166 53.3921 17.6716Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32188
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9059 30.4978C31.1281 30.7206 31.4193 30.8317 31.7112 30.8317C32.0031 30.8317 32.2944 30.7206 32.5165 30.4978C32.9614 30.0535 32.9614 29.3321 32.5165 28.8871L19.5386 15.9091C19.0943 15.4636 18.3729 15.4636 17.9279 15.9091C17.483 16.3534 17.483 17.0748 17.9279 17.5198L30.9059 30.4978Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32188
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8282 38.1994C41.3833 37.7532 40.6625 37.7538 40.2176 38.1988C39.772 38.6437 39.772 39.3645 40.217 39.8094L53.103 52.6973C53.3264 52.9194 53.617 53.0305 53.9089 53.0305C54.2002 53.0305 54.4921 52.92 54.7143 52.6979C55.1592 52.2536 55.1592 51.5315 54.7143 51.0866L41.8282 38.1994Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32188
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1656",
    x: 0.458008,
    y: 0.630737,
    width: 70.0938,
    height: 70.0938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1656",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotOk);
export default __webpack_public_path__ + "static/media/notOk.c51cc2713228b0c9526c81f816816aad.svg";
export { ForwardRef as ReactComponent };